document.addEventListener("DOMContentLoaded", () => {
  const wraps = document.querySelectorAll(".cc-wrap");
  if (!wraps.length) return;

  const waitForFabric = (cb, tries = 0) => {
    if (window.fabric) return cb();
    if (tries > 60) return;
    setTimeout(() => waitForFabric(cb, tries + 1), 100);
  };

  waitForFabric(() => {
    wraps.forEach((wrap) => {
      const MOCKUP_URL = wrap.dataset.mockupUrl;
      const uid = wrap.dataset.ccUid || "product";

      const canvasEl = wrap.querySelector(`#ccCanvas-${uid}`);
      const fileEl = wrap.querySelector(`#ccFile-${uid}`);
      const previewEl = wrap.querySelector(`#ccPreview-${uid}`);
      const originalEl = wrap.querySelector(`#ccOriginal-${uid}`);
      if (!MOCKUP_URL || !canvasEl || !fileEl || !previewEl || !originalEl) return;

      const size = Math.min(wrap.clientWidth || 360, 360);

      const canvas = new fabric.Canvas(canvasEl, {
        preserveObjectStacking: true,
        selection: false
      });

      canvas.setWidth(size);
      canvas.setHeight(size);
      canvas.backgroundColor = "transparent";

      let overlayMockup = null;
      let userImage = null;

      const bringOverlayToFront = () => overlayMockup && overlayMockup.bringToFront();

      // mockup overlay
      fabric.Image.fromURL(
        MOCKUP_URL,
        (img) => {
          const scale = size / img.width;
          img.set({
            left: 0,
            top: 0,
            scaleX: scale,
            scaleY: scale,
            selectable: false,
            evented: false
          });
          overlayMockup = img;
          canvas.add(overlayMockup);
          bringOverlayToFront();
          canvas.requestRenderAll();
        },
        { crossOrigin: "anonymous" }
      );

      // upload
      fileEl.addEventListener("change", (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (ev) => {
          const dataUrl = ev.target.result;
          originalEl.value = dataUrl;

          fabric.Image.fromURL(
            dataUrl,
            (img) => {
              if (userImage) canvas.remove(userImage);

              const targetW = size * 0.70;
              const targetH = size * 0.78;
              const scale = Math.min(targetW / img.width, targetH / img.height);

              img.set({
                left: (size - img.width * scale) / 2,
                top: (size - img.height * scale) / 2,
                scaleX: scale,
                scaleY: scale,
                hasRotatingPoint: false,
                lockRotation: true,
                transparentCorners: false,
                cornerStyle: "circle"
              });

              userImage = img;
              canvas.add(userImage);
              userImage.sendToBack();
              bringOverlayToFront();

              canvas.setActiveObject(userImage);
              canvas.requestRenderAll();
            },
            { crossOrigin: "anonymous" }
          );
        };
        reader.readAsDataURL(file);
      });

      // add to cart -> preview opslaan
      const form = wrap.closest("form");
      if (form) {
        form.addEventListener("submit", () => {
          if (userImage) {
            previewEl.value = canvas.toDataURL({ format: "png", quality: 1 });
          }
        });
      }

      // resize
      window.addEventListener("resize", () => {
        const newSize = Math.min(wrap.clientWidth || 360, 360);
        if (newSize === canvas.getWidth()) return;

        const factor = newSize / canvas.getWidth();
        canvas.setWidth(newSize);
        canvas.setHeight(newSize);

        canvas.getObjects().forEach((obj) => {
          obj.scaleX *= factor;
          obj.scaleY *= factor;
          obj.left *= factor;
          obj.top *= factor;
          obj.setCoords();
        });

        canvas.requestRenderAll();
      });
    });
  });
});
